import {popoverAnatomy} from '@chakra-ui/anatomy';
import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const {defineMultiStyleConfig} = createMultiStyleConfigHelpers(popoverAnatomy.keys);

export const PopoverTheme = defineMultiStyleConfig({
  baseStyle: {
    content: {
      width: `400px`,
      padding: `space-200`,
      borderRadius: `radius-200`,
      backgroundColor: `background.primary`,
      boxShadow: `xl`,
    },
  },
});
